import Card from 'features/common/components/Card'
import points from 'assets/points.svg'
import { useTranslation } from 'react-i18next'
import useStatistics from '../../common/hooks/useStatistics'
import Spinner from 'features/common/components/Spinner'
import star from 'assets/star-deep-yellow.svg'

const TipsCard = () => {
    const { t } = useTranslation()
    const { totalTips, stars, currency, isLoading } = useStatistics()

    return (
        <Card className="flex min-h-0 flex-col gap-6 p-10">
            <div className="flex items-center justify-between">
                <div className="text-xl font-bold">
                    {t('STATISTICS_CURRENT_MONTH')}
                </div>
                <div>
                    <img className="cursor-pointer" src={points} alt={'more'} />
                </div>
            </div>
            {isLoading ? (
                <div className="flex justify-center items-center p-10">
                    <Spinner className='w-20 h-20' yellow />
                </div>
            ) : (
                <div className="grid min-h-0 grid-cols-2">
                    <div className="flex flex-col items-center justify-center gap-6 text-5xl text-yellow-40">
                        <div className="flex items-center justify-center gap-4 font-extrabold">
                            <img src={star} className="w-10" />
                            {stars}
                        </div>
                        <div className="font-bold">{t('STATISTICS_CURRENT_MONTH_RATING')}</div>
                    </div>
                    <div className="flex h-56 w-56 flex-col items-center justify-center rounded-full bg-yellow-40 text-6xl font-bold text-white">
                        <div>{totalTips}</div>
                        <div>{currency?.toUpperCase()}</div>
                    </div>
                </div>
            )}
        </Card>
    )
}

export default TipsCard
